import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { dailyNoPar } from 'lib/api/time';
import { paramConverter } from 'modules/common';
import { setPortal } from 'modules/portal';

import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import NoParGraph from './NoParGraph';
import { useDispatch, useSelector } from 'react-redux';

const NoPar = () => {
  const initParams = {
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
  };

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    setInitialization(false);
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'STATS_DTTM').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
        let totalCheck = rowObj.STATS_DTTM === 'total';
        const showWindowUrl =
          '/report/media/nobanner?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&isPop=1';

        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );
        var dayOfWeek = new Date(dateValue).getDay();
        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = 'red';
        } else if (dayOfWeek === 6) {
          dayColor = 'blue';
        }

        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['STATS_DTTM'],
              statsDttm.type,
              statsDttm.format
            )}
            textColor={dayColor}
            icon={!totalCheck && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 미노출관리')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
      headStyle: {
        width: 70,
      },
    },
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
      </NewFilterWrap>
      <>
        <NoParGraph params={{ ...paramConverter(params) }} />

        <NewTableContainer
          dataReqPromise={dailyNoPar}
          params={{ ...params }}
          getParam={getParam}
          customized={customized}
          useSearch={false}
          noneSearch
        />
      </>
    </>
  );
};

export default NoPar;
